<template>
  <div>
    <a-tabs v-model="activeTab" @change="onTabChange">
      <!-- 抽奖规则 -->
      <a-tab-pane key="rules" tab="抽奖规则">
        <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="addRule">
          新增规则
        </a-button>
        <a-table
          :columns="ruleColumns"
          :row-key="record => record.objId"
          :data-source="ruleData"
          :pagination="rulePagination"
          :loading="ruleLoading"
          @change="handleRuleTableChange"
        >
          <template slot="name" slot-scope="text,record">
            <a-select v-model="record.name" :disabled="true" style="width: 100%">
              <a-select-option value="抽奖活动">抽奖活动</a-select-option>
            </a-select>
          </template>
          <template slot="status" slot-scope="text">
            <a-tag :color="text === 1 ? 'green' : text === 2 ? 'red' : 'black'">
              {{ text === 1 ? '进行中' : text === 2 ? '已结束' : '未开始' }}
            </a-tag>
          </template>
          <template slot="operate" slot-scope="text, record">
            <a href="javascript:;" @click="editRule(record)">编辑</a>
            <a-divider type="vertical" />
            <a href="javascript:;" @click="delRule(record)">删除</a>
          </template>
        </a-table>
      </a-tab-pane>

      <!-- 奖品列表 -->
      <a-tab-pane key="prizes" tab="奖品列表">
        <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="addPrize">
          新增奖品
        </a-button>
        <a-table
          :columns="prizeColumns"
          :row-key="record => record.objId"
          :data-source="prizeData"
          :pagination="prizePagination"
          :loading="prizeLoading"
          @change="handlePrizeTableChange"
        >
          <template slot="prizeType" slot-scope="text">
            {{ text === '0' ? '谢谢参与' : text === '1' ? '实物奖品' : text === '2' ? '虚拟奖品' : text }}
          </template>
          <template slot="isActive" slot-scope="text, record">
              <a-switch v-model="record.isActive" :checked-children="启用" :un-checked-children="禁用" @change="updatePrizeStatus(record)" />
          </template>
          <template slot="activityId" slot-scope="text, record">
            {{ activeObject.filter(item => item.objId === record.activityId)[0].name }}
          </template>
          <template slot="operate" slot-scope="text, record">
            <a href="javascript:;" @click="editPrize(record)">编辑</a>
            <a-divider type="vertical" />
            <a href="javascript:;" @click="delPrize(record)">删除</a>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <!-- 抽奖规则 新增/编辑弹窗 -->
    <a-modal v-model="ruleVisible" :title="ruleModalTitle" @ok="handleRuleOk" width="600px">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="活动名称">
          <a-select v-model="ruleForm.name" placeholder="请选择活动名称" :disabled="true">
            <a-select-option value="抽奖活动">抽奖活动</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model="ruleForm.status" placeholder="请选择状态">
            <a-select-option value=0>未开始</a-select-option>
            <a-select-option value=1>进行中</a-select-option>
            <a-select-option value=2>已结束</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="开始时间">
          <a-date-picker v-model="ruleForm.startTime" show-time format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
        </a-form-item>
        <a-form-item label="结束时间">
          <a-date-picker v-model="ruleForm.endTime" show-time format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
        </a-form-item>

        <!-- <a-form-item label="兑换所需积分">
          <a-input-number v-model="ruleForm.exchangePoints" :min="0" style="width: 100%" placeholder="积分为0则不限制" />
        </a-form-item> -->
        <a-form-item label="彩票兑换比例" >
          <a-input-number v-model="ruleForm.ticketsRatio" :min="0" style="width: 100%" placeholder="彩票兑换比例" />
          <span>比如：100彩票兑换1次抽奖,填0则不支持兑换</span>
        </a-form-item>
        <a-form-item label="积分兑换比例" >
          <a-input-number v-model="ruleForm.pointsRatio" :min="0" style="width: 100%" placeholder="积分兑换比例" />
          <span>比如：100签到积分兑换1次抽奖,填0则不支持兑换</span>
        </a-form-item>
        <a-form-item label="规则内容">
          <a-textarea v-model="ruleForm.rulesContent" :rows="4" placeholder="请输入抽奖规则说明" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 奖品 新增/编辑弹窗 -->
    <a-modal v-model="prizeVisible" :title="prizeModalTitle" @ok="handlePrizeOk" width="600px">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="奖品名称">
          <a-input v-model="prizeForm.name" placeholder="如：一等奖、谢谢参与、100游戏币" />
        </a-form-item>
        <a-form-item label="活动名称">
          <a-select v-model="prizeForm.activityId" placeholder="请选择活动类型"  >
            <a-select-option v-for="item in activeObject" :value="item.objId"  :key="item.objId">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="奖品类型">
          <a-select v-model="prizeForm.prizeType" placeholder="请选择奖品类型">
            <a-select-option value="0">谢谢参与</a-select-option>
            <a-select-option value="1">实物奖品</a-select-option>
            <a-select-option value="2">虚拟奖品(币/券)</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="奖品价值" v-if="prizeForm.prizeType === '2'">
          <a-input-number v-model="prizeForm.prizeValue" placeholder="如：100枚币" :min="0" style="width: 100%" />
        </a-form-item>
        <a-form-item label="中奖权重">
          <a-input-number v-model="prizeForm.weight" :min="0" style="width: 100%" placeholder="数值越大概率越高" />
          <span>数值越大概率中奖越大，计算方法：本奖品权重/全部奖品总权重=中奖概率</span>
        </a-form-item>
        <a-form-item label="奖品库存">
          <a-input-number v-model="prizeForm.stock" style="width: 100%" placeholder="-1为无限库存" />
        </a-form-item>
        <a-form-item label="排序位置">
          <a-input-number v-model="prizeForm.sortOrder" :min="0" style="width: 100%" placeholder="转盘扇区排序" />
          <span>数值越小越靠前</span>
        </a-form-item>
        <a-form-item label="扇区颜色">
          <a-select v-model="prizeForm.sectorColor" placeholder="请选择扇区颜色" allow-clear>
            <a-select-option v-for="color in colorList" :key="color" :value="color">
              <span style="display: inline-flex; align-items: center;">
                <span :style="{ display: 'inline-block', width: '16px', height: '16px', backgroundColor: color, border: '1px solid #d9d9d9', borderRadius: '2px', marginRight: '8px' }"></span>
                {{ color }}
              </span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="文字颜色">
          <a-select v-model="prizeForm.textColor" placeholder="请选择文字颜色" allow-clear>
            <a-select-option v-for="color in colorList" :key="color" :value="color">
              <span style="display: inline-flex; align-items: center;">
                <span :style="{ display: 'inline-block', width: '16px', height: '16px', backgroundColor: color, border: '1px solid #d9d9d9', borderRadius: '2px', marginRight: '8px' }"></span>
                {{ color }}
              </span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="是否启用">
          <a-switch v-model="prizeForm.isActive" :checked-children="启用" :un-checked-children="禁用" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  getLotteryRules,
  addLotteryRules,
  deleteLotteryRules,
  getPrizeList,
  addPrize,
  deletePrize,
  getColorList,
  editPrizeStatus
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
import dayjs from "dayjs";

const ruleColumns = [
  { title: "ID", dataIndex: "objId", align: "center", width: 80 },
  { title: "活动名称", dataIndex: "name", align: "center" },
  {
    title: "状态",
    dataIndex: "status",
    align: "center",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "开始时间",
    dataIndex: "startTime",
    align: "center",
    customRender: text => text ? dayjs(text).format("YYYY-MM-DD HH:mm") : "-",
  },
  {
    title: "结束时间",
    dataIndex: "endTime",
    align: "center",
    customRender: text => text ? dayjs(text).format("YYYY-MM-DD HH:mm") : "-",
  },
  // { title: "兑换积分", dataIndex: "exchangePoints", align: "center", customRender: text => text != null ? text : "-" },
  { title: "彩票比例", dataIndex: "ticketsRatio", align: "center", customRender: text => text != null ? text : "-" },
  { title: "积分比例", dataIndex: "pointsRatio", align: "center", customRender: text => text != null ? text : "-" },
  {
    title: "操作",
    dataIndex: "operate",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "operate" },
  },
];

const prizeColumns = [
  { title: "ID", dataIndex: "objId", align: "center", width: 80 },
  { title: "奖品名称", dataIndex: "name", align: "center" },
  { title: "活动名称", dataIndex: "activityId", align: "center", scopedSlots: { customRender: "activityId" } },
  {
    title: "奖品类型",
    dataIndex: "prizeType",
    align: "center",
    scopedSlots: { customRender: "prizeType" },
  },
  { title: "奖品价值", dataIndex: "prizeValue", align: "center" },
  { title: "中奖权重", dataIndex: "weight", align: "center" },
  { title: "奖品库存", dataIndex: "stock", align: "center", customRender: text => text === -1 ? "无限" : text },
  { title: "排序", dataIndex: "sortOrder", align: "center" },
  {
    title: "是否启用",
    dataIndex: "isActive",
    align: "center",
    scopedSlots: { customRender: "isActive" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      activeTab: "rules",
      // 抽奖规则
      ruleData: [],
      ruleLoading: false,
      ruleColumns,
      ruleVisible: false,
      ruleModalTitle: "新增抽奖规则",
      ruleForm: this.initRuleForm(),
      // 奖品列表
      prizeData: [],
      prizeLoading: false,
      prizeColumns,
      prizeVisible: false,
      prizeModalTitle: "新增奖品",
      prizeForm: this.initPrizeForm(),
      colorList: [],
      rulePagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      prizePagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      activeObject: {},
      checked: true,
    };
  },
  
  mounted() {
    this.getRuleData();
    this.getColorList();
  },
  props: ["formInline"],
  methods: {
    // ========== 抽奖规则 ==========
    initRuleForm() {
      return {
        objId: null,
        name: "抽奖活动",
        status: "0",
        startTime: null,
        endTime: null,
        rulesContent: "",
        exchangePoints: 0,
        ticketsRatio: 0,
        pointsRatio: 0,
      };
    },
    getRuleData() {
      this.ruleLoading = true;
      getLotteryRules().then(res => {
        this.ruleLoading = false;
        if (res && res.data) {
          this.ruleData = Array.isArray(res.data) ? res.data : [res.data];
          this.rulePagination.total = res.count;
          this.activeObject = this.ruleData.map(item => ({ objId: item.objId, name: item.name }));
          console.log(this.activeObject);
        } else {
          this.ruleData = [];
          message.info("暂无数据");
        }
      }).catch(() => {
        this.ruleLoading = false;
      });
    },
    onTabChange(key) {
      if (key === "rules") {
        this.getRuleData();
      } else if (key === "prizes") {
        this.getPrizeData();
      }
    },
    handleRuleTableChange(rulePagination) {
      this.getRuleData();
    },
    addRule() {
      this.ruleModalTitle = "新增抽奖规则";
      this.ruleForm = this.initRuleForm();
      this.ruleVisible = true;
    },
    editRule(row) {
      this.ruleModalTitle = "编辑抽奖规则";
      this.ruleForm = {
        objId: row.objId,
        name: row.name || "",
        status: row.status || "0",
        startTime: row.startTime ? dayjs(row.startTime) : null,
        endTime: row.endTime ? dayjs(row.endTime) : null,
        rulesContent: row.rulesContent || "",
        exchangePoints: row.exchangePoints || 0,
        ticketsRatio: row.ticketsRatio || 0,
        pointsRatio: row.pointsRatio || 0,

      };
      this.ruleVisible = true;
    },
    handleRuleOk() {
      if (!this.ruleForm.name) {
        message.warning("活动名称不能为空");
        return;
      }
      const params = {
        ...this.ruleForm,
        startTime: this.ruleForm.startTime ? dayjs(this.ruleForm.startTime).format("YYYY-MM-DD HH:mm:ss") : null,
        endTime: this.ruleForm.endTime ? dayjs(this.ruleForm.endTime).format("YYYY-MM-DD HH:mm:ss") : null,
      };
      this.ruleVisible = false;
      addLotteryRules(params).then(res => {
        message.success(res.info || "操作成功");
        this.getRuleData();
      }).catch(() => {
        message.error("操作失败");
      });
    },
    delRule(row) {
      const self = this;
      this.$confirm({
        title: "确认删除",
        content: `确定要删除抽奖规则"${row.name}"吗？`,
        onOk() {
          return deleteLotteryRules(row.objId).then(res => {
            message.success(res.info || "删除成功");
            self.getRuleData();
          });
        },
      });
    },

    // ========== 奖品列表 ==========
    initPrizeForm() {
      return {
        objId: null,
        name: "",
        prizeType: "1",
        prizeValue: null,
        weight: 0,
        stock: null,
        sortOrder: 0,
        sectorColor: "",
        textColor: "",
        isActive: true,
        activityId: null,
      };
    },
    getPrizeData() {
      this.prizeLoading = true;

      getPrizeList(
        this.formInline.name,
        this.prizePagination.current,
        this.prizePagination.pageSize
      ).then(res => {
        this.prizeLoading = false;
        if (res && res.data != null) {
          this.prizeData = Array.isArray(res.data) ? res.data : [res.data];
          this.prizePagination.total = res.count;
        } else {
          this.prizeData = [];
          message.info("暂无数据");
        }
      }).catch(() => {
        this.prizeLoading = false;
      });
    },
    handlePrizeTableChange(prizePagination) {
      this.getPrizeData();
    },
    addPrize() {
      this.prizeModalTitle = "新增奖品";
      this.prizeForm = this.initPrizeForm();
      this.prizeVisible = true;
    },
    editPrize(row) {
      this.prizeModalTitle = "编辑奖品";
      this.prizeForm = {
        objId: row.objId,
        name: row.name || "",
        prizeType: row.prizeType || "1",
        prizeValue: row.prizeValue || null,
        weight: row.weight || 0,
        stock: row.stock !== undefined ? row.stock : 0,
        sortOrder: row.sortOrder || 0,
        sectorColor: row.sectorColor || "",
        textColor: row.textColor || "",
        isActive: row.isActive !== undefined ? row.isActive : true,
        activityId: row.activityId,
      };
      this.prizeVisible = true;
    },
    handlePrizeOk() {
      if (!this.prizeForm.name) {
        message.warning("奖品名称不能为空");
        return;
      }
      if (!this.prizeForm.prizeType && this.prizeForm.prizeType !== "0") {
        message.warning("请选择奖品类型");
        return;
      }
      const params = { ...this.prizeForm };
      this.prizeVisible = false;
      addPrize(params).then(res => {
        message.success(res.info || "操作成功");
        this.getPrizeData();
      }).catch(() => {
        message.error("操作失败");
      });
    },
    delPrize(row) {
      const self = this;
      this.$confirm({
        title: "确认删除",
        content: `确定要删除奖品"${row.name}"吗？`,
        onOk() {
          return deletePrize(row.objId).then(res => {
            message.success(res.info || "删除成功");
            self.getPrizeData();
          });
        },
      });
    },
    getColorList() {
      getColorList().then(res => {
        if (res && res.data) {
          this.colorList = JSON.parse(res.data.record);
          console.log(this.colorList)
        }
      }).catch(() => {});
    },
    updatePrizeStatus(row) {
      editPrizeStatus(row.objId).then(res => {
        message.success(res.info || "操作成功");
        this.getPrizeData();
      }).catch(() => {
        message.error("操作失败");
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/lotteryActivity/lotteryActivityContent.vue